<template>
  <layout-vertical>

    <router-view />

    <!-- invisible by default so user can not play around with the UI style -->
    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@hw-ui/layouts/layout-vertical/LayoutVertical.vue'
import AppCustomizer from '@hw-ui/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@theme-config'

export default {
  components: {
    AppCustomizer,
    LayoutVertical,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
